export default {
  methods: {
    $__validationErrorClass(validation) {
      return validation.$dirty && validation.$error
        ? "leo-border-red"
        : "leo-border-success";
    },
    $__isValidationError(validation) {
      return validation.$dirty && validation.$error;
    },
  },
};
